import {TableProps} from "./index.types";
import {useNavigate} from "react-router-dom";
import {ReactNode} from "react";
import {ascending, descending} from "../../utils/constants";
// @ts-ignore
import { Loader } from '@airdao/ui-library';

const Table = ({ headingCells, rowCells, gridTemplateClassName, handleSort, sortInfo, isLinks, isLoading, label, additionalData, additionalLabel }: TableProps) => {
  const navigate = useNavigate();

  const handleRedirect = (row: ReactNode[]) => {
    const nav = row.find((el) => typeof el === 'string' && el.includes('navigate'));
    // @ts-ignore
    const navigateUrl = nav?.split ? nav.split(':')[1] : '';

    navigate(navigateUrl)
  };

  const renderRows = (list: any[]) => {
    return list.map((row, j) => (
      <div
        key={j}
        onClick={isLinks ? () => handleRedirect(row) : undefined}
        className={`table__row ${gridTemplateClassName} ${isLinks ? 'table__row_link' : ''}`}
      >
        {row.map((el: ReactNode | string, i: number) => !(typeof el === 'string' && el.includes('navigate')) && (
          <span className="table__cell" key={i}>
            {el}
          </span>
        ))}
      </div>
    ))
  }
  return (
    <div className={`table__container`}>
      {headingCells && (
        <div className={`table__heading ${gridTemplateClassName}`}>
          {headingCells.map(({ label, isSortAvailable }, i) => (
            <span className="table__cell" key={label} onClick={
              handleSort && isSortAvailable ? () => handleSort({
                direction: sortInfo?.direction === ascending ? descending : ascending,
                index: i,
              }) : undefined
            }>
            {label}
              {/*<Tooltip*/}
              {/*  isMultiline*/}
              {/*  message="The current total number of blocks <br/> in the chain since the genesis block"*/}
              {/*>*/}
              {/*  <img src={info} alt="tooltip"/>*/}
              {/*</Tooltip>*/}
          </span>
          ))}
        </div>
      )}
      {isLoading ? (
        <Loader />
      ) : (
        <div className="table__body">
          {rowCells && !!rowCells.length && (
            <>
              {label && (
                <div className="table__label">{label}</div>
              )}
              {renderRows(rowCells)}
            </>
          )}
          {additionalData && !!additionalData.length && (
            <>
              {label && (
                <div className="table__label" style={{ marginTop: '14px' }}>{additionalLabel}</div>
              )}
              {renderRows(additionalData)}
            </>
          )}
        </div>
      )}
    </div>
  )
};

export default Table;
